import { Banner } from "baseui/banner";
import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { Check } from "baseui/icon";
import { ListItem, ListItemLabel } from "baseui/list";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useSnackbar } from "baseui/snackbar";
import { useState, useEffect } from "react";
import { IAutomationObject } from "../../../automationObjects";
import { CreateRelationsCommand, RELATION_TYPE, useCreateRelationMutation } from "../../../services/objects";
import { ObjectNavigatorModal } from "../../ObjectSelector/Modal";
import { Notification } from 'baseui/notification';
import { useStyletron } from "baseui";
import { VscArrowDown } from "react-icons/vsc";
import { FormattedMessage, useIntl } from 'react-intl';

interface CreateRelationDialogProps {
    sourceObject: IAutomationObject,
    tragetObject: IAutomationObject,
    relationType: keyof typeof RELATION_TYPE,
    isOpen: boolean,
    setIsOpen: any
}
const CreateRelationDialog = ({ sourceObject, tragetObject, relationType, isOpen, setIsOpen }: CreateRelationDialogProps) => {
    const { enqueue } = useSnackbar();
    const intl = useIntl();
    const [createRelation, createRelationResult] = useCreateRelationMutation();
    const [selectedItem, setSeletctedItem] = useState<IAutomationObject>();
    const [css, theme] = useStyletron();

    function onCreateClick(): void {
        const cmd: CreateRelationsCommand = {
            fromObjectId: sourceObject?.id || selectedItem?.id || '',
            toObjectId: tragetObject?.id || selectedItem?.id || '',
            type: relationType,
            resourceGroupId: sourceObject?.resourceGroupId || tragetObject?.resourceGroupId || ''
        }
        createRelation(cmd);
    }

    const onSelected = (item: IAutomationObject) => { setSeletctedItem(item); };
    const [showObjectSelector, setShowObjectSelector] = useState(false);
    function onShowObjectSelector() {
        setShowObjectSelector(true);
    }

    useEffect(() => {
        if (createRelationResult?.isSuccess) {
            enqueue({
                message: intl.formatMessage({ id: "Relations.AddSuccessful", defaultMessage: 'Sucessfully added' }),
                startEnhancer: ({ size }) => <Check size={size} />,
            });
            setIsOpen(false);
        }
    }, [createRelationResult]);

    const filter = (app: IAutomationObject) => sourceObject ? app.resourceGroupId === sourceObject.resourceGroupId : app.resourceGroupId === tragetObject.resourceGroupId ;
    const fromSource = sourceObject;
    const fromToTextSelector = fromSource ? intl.formatMessage({ id: "Relations.Target", defaultMessage: "Target" }) : intl.formatMessage({ id: "Relations.Source", defaultMessage: "Source" });
    return (
        <>
            <Modal closeable onClose={() => setIsOpen(false)} isOpen={isOpen}>
                <ModalHeader>
                    <FormattedMessage id="Relations.CreateRelation" defaultMessage="Create new {relationType} Relation"
                        values={{
                            relationType: relationType
                        }} /></ModalHeader>
                <ModalBody>
                    <Block marginTop={theme.sizing.scale1200} display='flex' flexDirection='column' alignItems='center' gridGap={theme.sizing.scale500}>
                        {sourceObject &&
                            <>
                                <ListItem>
                                    <ListItemLabel description={<ItemDescription item={sourceObject}></ItemDescription>}>
                                        {sourceObject?.description}
                                    </ListItemLabel>
                                </ListItem>
                                <VscArrowDown color={theme.colors.primary} size={'3em'}></VscArrowDown>
                            </>
                        }
                        <Block display='flex' flexDirection='row' gridGap={theme.sizing.scale100}>
                            <Button onClick={onShowObjectSelector}><FormattedMessage id="Relations.SelectAppShort" defaultMessage="Select App" /></Button>
                            {selectedItem &&
                                <ListItem>
                                    <ListItemLabel description={<ItemDescription item={selectedItem}></ItemDescription>}>
                                        {selectedItem?.description}
                                    </ListItemLabel>
                                </ListItem>
                            }
                            {selectedItem === undefined &&
                                <Banner kind="warning">
                                    <FormattedMessage id="Relations.SelectAppNoification" defaultMessage="Please select an App as {sourceOrTarget}"
                                        values={{
                                            sourceOrTarget: fromToTextSelector
                                        }} /></Banner>
                            }

                        </Block>
                        {tragetObject &&
                            <>
                                <VscArrowDown color={theme.colors.primary} size={'3em'}></VscArrowDown>
                                <ListItem>
                                    <ListItemLabel description={<ItemDescription item={tragetObject}></ItemDescription>}>
                                        {tragetObject?.description}
                                    </ListItemLabel>
                                </ListItem>
                            </>
                        }
                        {showObjectSelector &&
                            <ObjectNavigatorModal currentSelectedParent={sourceObject ?? tragetObject} filter={filter} title={<FormattedMessage id="Relations.SelectApp" defaultMessage="Select an App as {sourceOrTarget}"
                            values={{
                                sourceOrTarget: fromToTextSelector
                            }} />}
                                isOpen={showObjectSelector}
                                setIsOpen={(e: boolean) => setShowObjectSelector(e)}
                                onSelected={onSelected}></ObjectNavigatorModal>
                        }
                    </Block>
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => { setIsOpen(false); }}>
                        <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                    <ModalButton onClick={onCreateClick} disabled={!selectedItem} isLoading={createRelationResult.isLoading}><FormattedMessage id="add" defaultMessage="Add" /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default CreateRelationDialog


function ItemDescription({ item }) {
    const [css] = useStyletron();
    return (
        <>
            {item.name}
            <br></br>
            <span className={css({
                fontSize: '0.8em'
            })}>
                {item.schema}
            </span>
            <br></br>
            <span className={css({
                fontSize: '0.8em'
            })}>
                {item.id}
            </span></>
    )
}